// @ts-nocheck
/* eslint-disable */
import { node } from "~/util/dom";
import Content from './content';
import { store } from "~/state/store";
import { watch, watchCurrentUser } from "~/state/util";
import { firmStats, isFirmFromPoi } from "~/util/review";
import { _ } from "~/i18n";
import { getIcon } from "~/util/providers/poiagg";
import { CONFIG } from "~/config";

/**
 * @class Obrázky z mediaserveru
 * @private
 */
export default class Media extends Content {
	constructor(data, options) {
		super(data || [], options);
		this._noUploadSources = ["di", "bs", "foto", "ffoto", "wcam"];
		this._myBuild();

		const w = watch(store.getState, "user", watchCurrentUser);
		this._storeUnsubscribe = store.subscribe(w(() => {
			this._showEditLink();
		}));
	}

	destroy() {
		this._dom.container.removeEventListener("click", this, false);
		this._dom.editLink.removeEventListener("click", this, false);

		if (this._dom.galleryBtn) {
			this._dom.galleryBtn.removeEventListener("click", this, false);
			this._dom.galleryBtn.remove();
		}

		if (this._dom.uploadBox) {
			Mapy.getComponent("imageUploader").removeUploadBox(this._dom.uploadBox);
		}

		this._storeUnsubscribe();

		super.destroy();
	}

	handleEvent(e) {
		e.preventDefault();
		e.target.blur();

		if (e.currentTarget == this._dom.galleryBtn) {
			if (isFirmFromPoi(this._options.detail)) {
				const { data: detailData } = store.getState().detail;

				firmStats("firmy-vizitka-akce", detailData, { typeId: 17 });
			}
			Mapy.getComponent("detail").openGallery();
			Mapy.getComponent("history").save();
		}
		else if (e.target == this._dom.editLink) {
			// editacni link -> otevrit upravu fotky
			Mapy.ProviderPhotos.mediaGet(this._options.detail.source == "foto" ? this._options.detail.id : this._data[0].id).then(function(data) {
				this._openEditPhoto(data.media, e.target.hasAttribute("data-log-source") ? e.target.getAttribute("data-log-source") : "mapy-editace");
			}.bind(this), this._showEditLink.bind(this));
		}
	}

	openGallery() {
		const { data, mark } = store.getState().detail;
		const galleryData = Mapy.getComponent("detail").getGalleryData();
		let imgUrl = galleryData && galleryData.best && galleryData.best.urls["1x1"] ? Mapy.CDN.setSize(galleryData.best.urls["1x1"], Mapy.CDN.SIZE_112_112) : "";

		if (!data) {
			return;
		}

		if (imgUrl === "" && data.typeId) {
			let icon = getIcon(data.typeId, { scale: 3 });
			if (icon && icon != "") {
				imgUrl = icon;
			}
		}

		Mapy.getComponent("gallery").activate().setData({
			source: data.source,
			id: data.id,
			title: data.title,
			detail: {
				coords: [mark.lon, mark.lat],
				typeId: data.typeId,
				typeName: data.typeName,
				geom: data.geom,
			},
			imgUrl,
			hideUploadButton: (data.extend?.poi?.booking && data.source !== "firm") || data.source === "di",
		});
	}

	/**
	 * Vloží do kontejneru tlačítko pro upload fotky
	 */
	addUploadBox() {
		if (this._dom.uploadBox && !this._dom.container.contains(this._dom.uploadBox) && !this._dom.container.contains(this._dom.editLink) && !this._options.preferWebcam && !this._isBooking && this._noUploadSources.indexOf(this._options.detail.source) == -1) {
			this._dom.container.appendChild(this._dom.uploadBox);
		}
	}

	_myBuild() {
		this._isBooking = this._options.detail.extend.poi.booking && !isFirmFromPoi(this._options.detail);
		this._galleryData = [];

		if (!this._isBooking && this._noUploadSources.indexOf(this._options.detail.source) == -1) {
			this._createUpload();
		}

		this._createEdit();
		this._createGallery();
	}

	_openEditPhoto(imageData, source) {
		if (!imageData) { return; }

		var poi = {
			source: "foto",
			mark: imageData.mark,
			id: imageData.id
		}

		var param = {
			poi: poi,
			data: [imageData],
			editMode: true,
			source
		};

		Mapy.getComponent("imageUploader").activate().setData(param);
	}

	_createUpload(force) {
		const { data } = store.getState().detail;

		if (this._noUploadSources.indexOf(data.source) === -1 || force) {
			this._dom.uploadBox = Mapy.getComponent("imageUploader").getUploadBox(data);
			this._dom.uploadBox.setAttribute("data-log-source", "mapy-detail-button");
			this._dom.container.classList.add("content-uploadlink");
			this._dom.container.classList.add("noprint");
			this.addUploadBox();

			if (this._options.detail.upload) {
				Mapy.getComponent("imageUploader").activate().setData({
					poi: {
						source: this._options.detail.source,
						id: this._options.detail.id,
						mark: this._options.detail.mark,
					},
					source: "mapy",
					type: "empty",
				});
			}
		}
	}

	_createEdit() {
		const { data } = store.getState().detail;

		this._dom.editLink = document.createElement("button");
		this._dom.editLink.setAttribute("type", "button");
		this._dom.editLink.innerHTML = _("detail.content.editPhoto");
		this._dom.editLink.classList.add("edit-button");
		this._dom.editLink.setAttribute("data-log-source", "mapy-detail-editace");
		this._dom.editLink.setAttribute("data-log-origin", "fotky");
		this._dom.editLink.setAttribute("data-log-type", data && data.source === "coor" ? "coor" : "poi");

		this._dom.editLink.addEventListener("click", this, false);

		this._showEditLink();
	}

	_createGallery() {
		const { data: detailData } = store.getState().detail;

		if (this._data.length) {
			if (detailData) {
				this._dom.galleryBtn = node("a", { href: `https://${CONFIG.BASE_URL}/?source=${detailData.source}&id=${detailData.id}&gallery=1`, innerHTML: _("detail.view.gallery"), className: "icon gallery show" });
				this._dom.galleryBtn.addEventListener("click", this, false);

				var placeholderEl = this._options.placeholder;
				placeholderEl.parentNode.insertBefore(this._dom.galleryBtn, placeholderEl);

				this._data.forEach(function(media) {
					var largeSrc = Mapy.CDN.setSize(media.urls["default"], Mapy.CDN.SIZE_667_500);
					var author = media.authorName || "";

					// pridame do dat k sestavovani velke galerie - od prvni az po posledni fotku
					this._galleryData.push({
						src: largeSrc,
						authorName: author,
						authorId: media.authorId,
						takeDate: media.takeDate,
						mark: media.mark || "mark" in detailData ? detailData.mark : {},
						id: media.id
					});
				}, this);
			}
		}

		/* pokud je otevrena komponenta s galerii, pak se obnovujeme z URL a ona od nas potrebuje data */
		const gallery = Mapy.getComponent("gallery");
		const galleryData = gallery.getData();

		if (
			gallery.isActive()
			&& galleryData.source === detailData?.source
			&& parseInt(galleryData.id) === parseInt(detailData?.id)
		) {
			this.openGallery();
		}
	}

	_showEditLink() {
		const { user } = store.getState().user;
		const userPublicId = user.userPublicId;
		if (userPublicId && this._data.length && this._data[0].userPublicId && this._data[0].userPublicId == userPublicId && this._options.detail.source == "foto") {
			if (!this._dom.uploadBox) {
				this._createUpload(true);
				this._dom.container.appendChild(this._dom.uploadBox);
			}
			if (this._dom.uploadBox.parentNode == this._dom.container) {
				this._dom.uploadBox.remove();
				this._dom.container.appendChild(this._dom.editLink);
			}
		}
		else {
			if (this._dom.editLink.parentNode == this._dom.container) {
				this._dom.editLink.remove();
				if (this._dom.uploadBox) {
					this._dom.container.appendChild(this._dom.uploadBox);
				}
			}
		}
	}
}
